import { useState } from 'react';
import type { LaboratoryStroageData } from '../../../native-module';

export const useLaboratorySetting = (key: keyof LaboratoryStroageData) => {
  const [isOn, setIsOn] = useState<boolean | undefined>(undefined);
  console.log(
    `useLaboratorySetting called with key: ${key}, but it's a no-op on web.`,
  );
  return { isOn, setIsOn };
};
